import store from "store";

const LOCAL_CONTACTS_KEY = 'contact-list';

export default {
    pull() {
        const target = store.get(LOCAL_CONTACTS_KEY);
        if (!target) {
            return {};
        }

        return Object.fromEntries(target);
    },

    push(contact) {
        const target = this.pull();
        target[contact.uid] = contact;
        return this.save(target);
    },

    remove(uid) {
        const target = this.pull();
        delete target[uid];
        return this.save(target);
    },

    save(target) {
        const list = Object.entries(target);
        store.set(LOCAL_CONTACTS_KEY, list);
        return target;
    },

    getContact(uid) {
        const target = this.pull();
        return target[uid] || null;
    },
}